import { render, staticRenderFns } from "./MantenedorCoordinadorBase.vue?vue&type=template&id=04b000b0&"
import script from "./MantenedorCoordinadorBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorCoordinadorBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorCoordinadorBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports